@if (!isBackofficeRoute()) {
<app-header></app-header>
<app-email-verify-banner></app-email-verify-banner>
<app-cart-drawer></app-cart-drawer>
}
 <div id="cr-overlay" class="w-full h-full fixed top-[0] right-[0] left-[0] bottom-[0] bg-[#fff] flex items-center justify-center z-[99]" [class.hidden]="!overlayService.isOverlayVisible()">
        <span class="loader w-[10px] h-[10px] rounded-[50%] inline-block relative text-[#64b496] left-[-100px]"></span>
    </div>
<router-outlet></router-outlet>
@if (!isBackofficeRoute()) {
<app-footer></app-footer>
<app-whatsapp></app-whatsapp>
}
 <!-- <app-chat></app-chat> -->
